import { ASTNode } from "react-native-markdown-display";
import type MarkdownIt from "markdown-it";
import { RuleInline } from "markdown-it/lib/parser_inline.mjs";

// will match any text in between breakets like son [success]text that will be matched[/success]

const parseCustomEmphasis: RuleInline = (state, silent) => {
  const start = state.pos;

  if (state.src.charCodeAt(start) !== 0x5b) return false;

  const openMatch = state.src.slice(start).match(/^\[(\w+)\]/);
  if (!openMatch) return false;

  const tag = openMatch[1];
  const openTag = `[${tag}]`;
  const closeTag = `[/${tag}]`;
  const openTagEnd = start + openTag.length;

  const remainingText = state.src.slice(openTagEnd);
  const closeIndex = remainingText.indexOf(closeTag);
  if (closeIndex === -1) return false;

  const content = remainingText.slice(0, closeIndex);
  if (!content.trim()) return false;
  if (silent) return true;

  const token = state.push("custom_emphasis", "span", 0);
  token.content = content;
  token.markup = tag ?? "";

  state.pos = openTagEnd + closeIndex + closeTag.length;

  return true;
};

export const customeEmphasis = (md: MarkdownIt) => {
  md.inline.ruler.before("emphasis", "custom_emphasis", parseCustomEmphasis);
};

export interface ExtendedASTNode extends ASTNode {
  sourceInfo: string | undefined;
}
